import {
  SIDE_NAV_LIGHT,
  NAV_TYPE_SIDE,
  DIR_LTR,
} from "constants/ThemeConstant";
import { env } from "./EnvironmentConfig";

export const APP_NAME = "Lively";
export const STAGING_URL = "https://staging-api.lively.li";
export const PRODUCTION_URL = "https://api.lively.li";
export const API_BASE_URL = PRODUCTION_URL;
export const API_BASE_URL_V2 = PRODUCTION_URL + "/cms";
export const API_BASE_URL_STAGING = PRODUCTION_URL;
export const API_BASE_URL_V2_STAGING = PRODUCTION_URL + "/cms";
export const WEB_SOCKET_URL =
  "wss://253ul4moik.execute-api.ap-south-1.amazonaws.com/production";
export const APP_PREFIX_PATH = "/app";
export const AUTH_PREFIX_PATH = "/auth";
export const REDIRECT_URL_KEY = "redirect";
export const INTERACTIVE_MAIN_MENU_KEY = "lively_main_menu_interactive_2024";
export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/dashboards/default`;
export const LIVE_STREAM_ENTRY = `${APP_PREFIX_PATH}/live-call/stream/schedule`;
export const SHOP_DOMAIN_ENTRY = `${APP_PREFIX_PATH}/shopify/plans`;
export const UNAUTHENTICATED_ENTRY = "/login";
export const PRODUCTION_RTMP_ID= "oe1Gk8sh5jRVdFlwyg2Wb_stg";
export const STAGING_RTMP_ID= "oe1Gk8sh5jRVdFlwyg2Wb"
export const LIVELY_LOGO =
  "https://uploads-ssl.webflow.com/6466992f68dcc33a1f55edca/6469805dab8a9b8f10fd9362_Screenshot_2023-05-21_075146-removebg-preview.png";

export const THEME_CONFIG = {
  navCollapsed: false,
  sideNavTheme: SIDE_NAV_LIGHT,
  locale: "en",
  navType: NAV_TYPE_SIDE,
  topNavColor: "#3e82f7",
  headerNavColor: "",
  mobileNav: false,
  currentTheme: "light",
  direction: DIR_LTR,
  blankLayout: false,
};

export const FACEBOOK_AUTH_APP_ID = "409736351933885";
export const FACEBOOK_AUTH_CONFIG_ID = "1432399781489984";
export const EVENTS_API_BASE_URL = "https://event.lively.li/api";
export const GRAPH_QL_VERSION = "2025-01";